import React from 'react'

import { useReactiveVar } from '@apollo/client'

import useGetExposureNotifications from '@web/hooks/useGetExposureNotifications'
import { darkModeVar } from '@web/hooks/useGlobalDetermineDarkMode'
import { isEmptyArray } from '@web/libs/utils'

import Clickable from '../Clickable'
import { LANBannerHeight, LANExposureArea } from './LANBanner.constant'
import styles from './LANBanner.module.scss'

interface Props {
  exposureArea: LANExposureArea
  height?: LANBannerHeight
  nClickCodes?: {
    light: string
    dark: string
  }
}

const LANBanner = ({ exposureArea, height = LANBannerHeight.DEFAULT, nClickCodes }: Props) => {
  const dark = useReactiveVar(darkModeVar)
  const { notifications } = useGetExposureNotifications(exposureArea)

  if (isEmptyArray(notifications)) return null

  const index = Math.floor(Math.random() * notifications.length)
  const banner = notifications[index]

  const { r, g, b } = banner.bgColor

  // 배너에 있는 클릭코드 우선반영 LAN 완전히 fadeout되면 banner.clikCode로 통일
  const nClickCode = banner.clickCode ? banner.clickCode : dark ? nClickCodes?.dark : nClickCodes?.light

  return (
    <Clickable
      href={banner.linkUrl ?? undefined}
      className={styles.banner_area}
      nClickCode={nClickCode}
      nClickCid={banner.id}
    >
      <div style={{ backgroundColor: `rgb(${r}, ${g}, ${b})` }}>
        <img
          className={styles.img}
          src={banner.contentUrl}
          width="100%"
          height={height}
          alt={`${banner.title} ${banner.description}`}
        />
      </div>
    </Clickable>
  )
}

export default LANBanner
